export const SortDirection = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];

export const SortField = {
  None: 'none', // manual / backend order
  Title: 'title',
  UpdatedAt: 'updatedAt',
  CreatedAt: 'createdAt',
  Custom: 'custom', // domain-specific meaning
} as const;

export type SortField = (typeof SortField)[keyof typeof SortField];

export interface SortSpec {
  field: SortField;
  direction?: SortDirection;
}

export const DefaultSortSpec: SortSpec = {
  field: SortField.Title,
  direction: SortDirection.Asc,
};
